import { Box, Divider } from '@chakra-ui/react'
import { substanceUseCounselingField } from '@hb/shared'
import { FormElement } from '../../../../components/forms/Input'
import { SectionLabel } from '../../SectionLabel'

export const SubstanceUseCounselingInput = () => (
  <Box px={4} py={3} w="100%" data-child-name="data.substanceUseCounseling">
    <SectionLabel mb={1}>Substance Use &amp; Tobacco Counseling</SectionLabel>
    <Divider mb={2} />
    <FormElement
      root
      showName={false}
      field={substanceUseCounselingField}
      name="data.substanceUseCounseling"
    />
  </Box>
)
